import * as React from 'react';
import classnames from 'classnames';
import { ImageItem } from '../types';
import { Loading } from '../../../loading';

interface GalleryTabProps {
  imagesList: ImageItem[];
  isLoading: boolean;
  selectedImageId: string;
  onImageSelect: (imageId: string) => void;
  onDeleteImage: (imageId: string) => void;
}

export const GalleryTab: React.FC<GalleryTabProps> = ({
  imagesList,
  isLoading,
  selectedImageId,
  onImageSelect,
  onDeleteImage
}) => {
  if (isLoading) {
    return (
      <div className="gallery-loading">
        <Loading size="64" />
        <p className="loading-text">Loading your image library...</p>
      </div>
    );
  }

  if (!imagesList.length) {
    return (
      <div className="gallery-empty">
        <div className="empty-state">
          <div className="empty-icon">📁</div>
          <h3>No Images in Library</h3>
          <p>Upload images or generate with AI to build your library</p>
        </div>
      </div>
    );
  }

  return (
    <div className="gallery-tab">
      <div className="gallery-header">
        <h5>Choose from your image library</h5>
        <p className="text-muted">Select an image from your saved collection</p>
      </div>

      <div className="gallery-grid">
        {imagesList.map((image) => (
          <div
            key={image.imageId}
            className={classnames('gallery-item', {
              'selected': selectedImageId === image.imageId
            })}
            onClick={() => onImageSelect(image.imageId)}
          >
            <div className="image-container">
              <img
                src={image.cdnUrl}
                alt="Gallery item"
                className="gallery-image"
              />
              <button
                className="delete-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteImage(image.imageId);
                }}
                title="Delete image"
              >
                <i className="fa fa-trash"></i>
              </button>
            </div>
            <div className="image-info">
              <span className="image-dimensions">
                {image.width} × {image.height}
              </span>
            </div>
            {selectedImageId === image.imageId && (
              <div className="selection-indicator">
                ✓
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};